const $ = window.jQuery;

//
// Match ad height to post block
//
window.icSidebarAdMatchHeight = function() {
	const postHeight = $( '.posts .post' ).height();
	if ( postHeight ) {
		$( '.ic-cta-sidebar .ic-cta-quote-form' ).css( 'min-height', ( postHeight + 2 ) + 'px' );
	}
}

icSidebarAdMatchHeight();
$( window ).resize( icSidebarAdMatchHeight );
